
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import PositionCards from './components/PositionCards';
import BenefitsSection from './components/BenefitsSection';
import GallerySection from './components/GallerySection';

export default function VolunteerPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <PositionCards />
      <BenefitsSection />
      <GallerySection />
      <Footer />
    </div>
  );
}
